<template>
  <div class="horizontal-layout">
    <div class="horizontal-scroll-wrapper"
         :class="{'blend': canScrollRight, 'cursor-pointer': scrollDisabled}"
         @click="scrollDisabled ? $emit('expand') : null"
         ref="scrollerWrap">
      <div class="horizontal-scroll-container" ref="scroller" @scroll="onScroll" :class="{'no-scroll': scrollDisabled}">
        <div class="row flex-nowrap w-100 align-items-center">
          <slot></slot>
          <!-- Load more sentinel -->
          <div ref="sentinel" class="sentinel" v-show="hasPagination">
            <b-spinner variant="primary" label="Spinning" class="ml-2" small v-if="loadingMore"/>
          </div>
        </div>
        <slot name="counter"></slot>
      </div>
      <div ref="swipeHelp" :class="{'is-hidden': hideHelp}" class="swipe-help d-md-none" v-if="canScrollRight">
        <img src="@/assets/misc/swipe-left.gif" alt="Swipe left to load more">
      </div>
    </div>
    <div class="navigation mb-2 d-none d-md-flex" v-if="canScrollLeft || canScrollRight">
      <b-link @click="scroll('left')" :disabled="!canScrollLeft">
        <Icon name="chevronLeft" width="24"/>
      </b-link>
      <b-link @click="scroll('right')" :disabled="!canScrollRight" class="ml-2">
        <Icon name="chevronRight" width="24"/>
      </b-link>
    </div>
  </div>
</template>

<script>


export default {
  name: "HorizontalScroller",
  components: {},
  data() {
    return {
      resizeHandler: null,
      canScrollLeft: false,
      canScrollRight: false,
      hideHelp: false,
      previousScrollLeft: 0 // Used to determine scroll direction
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    hasPagination: {
      type: Boolean,
    },
    scrollDisabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // Create a bound handler to ensure proper cleanup
    this.resizeHandler = this.handleWindowResize.bind(this)
    window.addEventListener('resize', this.resizeHandler)
  },

  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
      this.resizeHandler = null
    }
  },

  methods: {
    init() {
      this.createObserver()
      this.onScroll({type: 'scroll'}, {isInitialState: true})
    },
    handleWindowResize() {
      // Default implementation - override in components
      if (this.onScroll && typeof this.onScroll === 'function') {
        this.onScroll({type: 'resize'}, {isInitialState: true})
      }
    },
    createObserver() {
      const observer = new IntersectionObserver(this.handleIntersect, {threshold: [1]})
      observer.observe(this.$refs.sentinel)
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$emit('load-more')
        }
      })
    },
    scroll(direction) {
      const elScrollableWrap = this.$refs.scrollerWrap
      const elScrollable = this.$refs.scroller
      let scrollAmount = elScrollableWrap.offsetWidth * 0.5 // 50% of the available scroll width
      elScrollable.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      })
    },
    onScroll($event, args = {isInitialState: false}) {
      const elScrollableWrap = this.$refs.scrollerWrap
      const elScrollable = this.$refs.scroller
      const tolerance = 40

      if (!elScrollable || !elScrollableWrap) return

      if ((elScrollable.scrollLeft !== this.previousScrollLeft) || args.isInitialState) {
        this.canScrollLeft = elScrollable.scrollLeft > tolerance
        this.canScrollRight = elScrollable.scrollLeft + elScrollableWrap.offsetWidth < elScrollable.scrollWidth - tolerance

        if (!args.isInitialState) this.hideHelp = true
        this.previousScrollLeft = elScrollable.scrollLeft
      }
    }
  }
}
</script>